import { GetStaticProps } from "next";
import { PreviewSuspense } from "next-sanity/preview";

import { LazyPreviewPage } from "../../../page/LazyPreviewPage";
import { LoadingScreen } from "../../../page/LoadingScreen";
import { PAGE_DATA_QUERY } from "../../../page/query";
import { PageData } from "../../../page/types";
import { client } from "../../../sanity/client";

import DemandeUnCreditPagesHepler from "../../../pagesHelpers/DemandeUnCredit";
interface PageProps {
  data: PageData | null;
  preview: boolean;
  slug?: string | null;
  token: string | null;
}

interface Query {
  [key: string]: string;
}

interface PreviewData {
  token?: string;
}

export const getStaticProps: GetStaticProps<
  PageProps,
  Query,
  PreviewData
> = async (ctx) => {
  let { params = {}, preview = false, previewData = {} } = ctx;
  params.slug = "demander-un-credit";
  if (preview && previewData.token) {
    return {
      props: {
        data: null,
        preview,
        slug: "demander-un-credit",
        token: previewData.token,
      },
    };
  }

  const data = await client.fetch<PageData | null>(PAGE_DATA_QUERY, params);

  return {
    props: {
      data,
      preview,
      slug: params?.slug.replace("/fr", "").replace("/ar", "") || null,
      token: null,
    },
  };
};

export default function Page(props: PageProps) {
  const { data, preview, token } = props;

  if (preview) {
    return (
      <PreviewSuspense
        fallback={<LoadingScreen>Loading preview…</LoadingScreen>}
      >
        <LazyPreviewPage slug={"demander-un-credit"} token={token} />
      </PreviewSuspense>
    );
  }
  return <DemandeUnCreditPagesHepler data={data} />;
}
